import { render, staticRenderFns } from "./JourneyDashboard.vue?vue&type=template&id=5781a136&scoped=true"
import script from "./JourneyDashboard.vue?vue&type=script&lang=js"
export * from "./JourneyDashboard.vue?vue&type=script&lang=js"
import style0 from "./JourneyDashboard.vue?vue&type=style&index=0&id=5781a136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781a136",
  null
  
)

export default component.exports